import React from 'react';
import { observer } from 'mobx-react';
import { Popup } from '@gamiphy/loyalty-station-desktop/components/popup';
import { Category, UserMissionsStatuses } from '@gamiphy/bl/mission';
import {
  Box,
  DialogContent, DialogTitle, Grid, IconButton, Typography,
} from '@mui/material';
import { Close } from '@mui/icons-material';
import { MissionsStore } from '@gamiphy/loyalty-station-desktop/store/mission';
import { useDisplayStringValue } from '@gamiphy/react-i18n';
import SVG from 'react-inlinesvg';
import ParallelMissionContent from './ParallelMissionContent';

export type Props = {
  category?: Category,
  onClose: (arg: boolean) => void,
  open: boolean,
};

const Categorypopup: React.FC<Props> = observer(({
  category, onClose, open,
}) => (
  <Popup
    fullWidth
    open={open}
    onClose={onClose}
    PaperProps={{
      sx: {
        maxHeight: '500px',
      },
    }}
  >
    <DialogTitle
      height={72}
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      borderBottom="1px solid #DFDFDF"
      sx={{
        px: 1,
        py: 1.5,
      }}
    >
      <Box display="flex" flexWrap="nowrap" alignItems="center">
        <Box
          width={40}
          height={40}
          borderRadius="50%"
          display="flex"
          justifyContent="center"
          alignItems="center"
          sx={{
            backgroundColor: 'primary.main',
            mr: 2,
            '& path': {
              stroke: (theme) => theme.palette.text.secondary,
            },
          }}
        >
          <SVG src={category?.image ?? ''}>
            <Box component="img" src={category?.image} />
          </SVG>
        </Box>
        <Typography>
          {useDisplayStringValue(category?.title)}
        </Typography>
      </Box>
      <IconButton
        onClick={() => onClose(false)}
        sx={{
          width: '48px',
          height: '48px',
          borderRadius: '8px',
          backgroundColor: 'rgba(0, 0, 0, 0.03)',
        }}
      >
        <Close fontSize="large" />
      </IconButton>
    </DialogTitle>
    <DialogContent sx={{
      p: 1,
      pt: '8px !important',
      '&::-webkit-scrollbar': {
        width: '5px',
      },
      '&::-webkit-scrollbar-track': {
        m: 1,
      },
      '&::-webkit-scrollbar-thumb': {
        background: 'gray',
        borderRadius: '50px',
      },
    }}
    >
      <Grid container>
        {MissionsStore.getMissionsByCategory(category)
          .filter((mission) => mission.status === UserMissionsStatuses.completed)
          .map((userMission) => (
            <Grid item xs={12} py={1} key={userMission.id}>
              <ParallelMissionContent userMission={userMission} />
            </Grid>
          ))}
        {MissionsStore.getMissionsByCategory(category)
          .filter((mission) => mission.status === UserMissionsStatuses.active)
          .map((userMission) => (
            <Grid item xs={12} py={1} key={userMission.id}>
              <ParallelMissionContent userMission={userMission} />
            </Grid>
          ))}
      </Grid>
    </DialogContent>
  </Popup>
));

export default Categorypopup;
